import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import UseSegmentImage from './UseSegmentImage'

const copy = {
  heading: `Use Segment to integrate with internal systems and best-in-class tools`,
  description: `See the complete view of your patient or member by unifying data across web, mobile web, apps, support and offline interactions.`,
}

const UseSegment: FC = () => (
  <StyledSectionBase variant="2Col">
    <SectionContents>
      <UseSegmentImage alt={`Illustration: ${copy.heading}`} />
    </SectionContents>
    <StyledCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description>{copy.description}</CopyText.Description>
      </CopyTextBase>
    </StyledCopy>
  </StyledSectionBase>
)

export default UseSegment

const SectionContents = styled(Section.Contents)`
  margin: auto 0;
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    align-self: center;
  }
`
